import { defineStore } from 'pinia'
import http from '@/services/http'
import { useAppStore } from '@/stores/modules/app'

export const useAppsStore = defineStore('apps', {
    state: () => {
        return {
            apps: [],
            appID: null,
            app: {
                aboutApp: {
                    id: null,
                    nameApp: null,
                    supportEmail: null,
                    applicationDescription: null,
                    billingModel: null,
                    billing: null,
                    isPrivate: null,
                },
                configApp: [],
                imagesApp: {}
            }
        }
    },
    getters: {
        getLogo: state => state.app.imagesApp,
    },
    actions: {
        async getAllApps() {
            this.apps = await http.get('/apps').then(response => {
                const {
                    data: { data }
                } = response

                return data
            })
        },
        setApps(apps) {
            this.apps = apps
        },
        setAppID(appID) {
            const appStore = useAppStore()
            this.appID = appID
            appStore.app.id = appID
        },
        setLogo(logo) {
            return this.app.imagesApp = logo
        }
    },
    persist: true
})
